import { render } from "./ToggleAssistentes.vue?vue&type=template&id=7338709a&scoped=true"
import script from "./ToggleAssistentes.vue?vue&type=script&lang=js"
export * from "./ToggleAssistentes.vue?vue&type=script&lang=js"

import "./ToggleAssistentes.vue?vue&type=style&index=0&id=7338709a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7338709a"]])

export default __exports__